import axios from 'axios'
export default {
  /* -  Merchants actions -  */
  getMerchants: (page = 1, pagination = true) => axios.get(`/merchants`, { params: { page: page, pagination: pagination } }),
  getMerchant: (merchantId) => axios.get(`/merchants/${merchantId}`),
  // This probably won't be used, keep in mind just in case
  postMerchant: (merchantData) => axios.post(`/merchants`, merchantData),
  putMerchant: (merchantId, merchantData = {}) => axios.put(`/merchants/${merchantId}`, merchantData),
  putMerchantLogo: (merchantId, merchantLogo) => axios.post(`/merchants/${merchantId}/logo`, merchantLogo),
  /* -  Activity Groups Actions - */
  getActivityGroups: (page = 1, pagination = true) => axios.get(`/activity_groups`, { params: { page: page, pagination: pagination } }),
  getActivityGroup: (activityGroupId) => axios.get(`/activity_groups/${activityGroupId}`),
  postActivityGroupLogo: (activityGroupId, activityGroupLogo) => axios.post(`/activity_groups/${activityGroupId}/logo`, activityGroupLogo)

}
